export var API_BASE_URL = "".concat(window.location.origin, "/");
export var APP_URL = window.location.origin;
